export const general = (state) => {
  return state.general.data || {}
}

export const generalLoading = (state) => {
  return state.general.loading
}

export const generalLastUpdate = (state) => {
  return state.general.lastUpdate
}
